import {
  FETCH_SELLER_STOREFRONT_REQUEST,
  FETCH_SELLER_STOREFRONT_SUCCESS
} from "../constants/actionTypes";
import { createReducer } from "../utils";

const initialState = {
  isFetching: true,
  storefront: []
};

export const storefrontReducer = createReducer(initialState, {
  [FETCH_SELLER_STOREFRONT_REQUEST]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: true
    };
  },
  [FETCH_SELLER_STOREFRONT_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false
    };
  }
});

export default storefrontReducer;
